import { useState } from 'react';
import { api } from '../lib/api.js';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const AuthDialog = ({ open, onClose }: Props) => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    setErr(null);
    try {
      await api.requestMagicLink(email);
      setSent(true);
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40" onClick={onClose} role="dialog">
      <div
        className="w-[380px] max-w-[92vw] rounded-xl bg-white dark:bg-neutral-900 shadow-2xl ring-1 ring-black/10 p-5 flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold text-neutral-800 dark:text-neutral-100">Sign in</h2>
          <button className="text-neutral-500 text-lg" onClick={onClose} aria-label="close">×</button>
        </div>

        {sent ? (
          <div className="text-sm text-neutral-700 dark:text-neutral-200">
            <p>Magic link sent (stub). Cek email <b>{email}</b> — dalam v0.1 backend belum kirim email
              beneran; endpoint respond <code>sent_stub</code>.</p>
          </div>
        ) : (
          <>
            <label className="text-xs uppercase tracking-wide text-neutral-500 dark:text-neutral-400">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="h-9 px-2.5 rounded-md border border-neutral-300 dark:border-neutral-700 text-sm bg-white dark:bg-neutral-800"
            />
            <div className="flex gap-2">
              <button
                disabled={busy || !email.includes('@')}
                onClick={submit}
                className="flex-1 h-9 rounded-md bg-sky-500 text-white text-sm font-medium disabled:opacity-50"
              >
                {busy ? 'Sending…' : 'Send magic link'}
              </button>
            </div>
            <div className="text-[11px] text-neutral-500 dark:text-neutral-400">
              Atau lanjut sebagai guest — semua fitur canvas jalan tanpa login (LocalStorage save).
            </div>
            {err ? <div className="text-xs text-rose-500">{err}</div> : null}
          </>
        )}
      </div>
    </div>
  );
};
